import { render, staticRenderFns } from "./menuAdd.vue?vue&type=template&id=6f674f2c&scoped=true&"
import script from "./menuAdd.vue?vue&type=script&lang=js&"
export * from "./menuAdd.vue?vue&type=script&lang=js&"
import style0 from "./menuAdd.vue?vue&type=style&index=0&id=6f674f2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f674f2c",
  null
  
)

export default component.exports